import React, { useState } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

import './BrandForm.scss'

import ShipSelect from '../ShipSelect/ShipSelect'
import DatepickerModal from '../DatepickerModal/DatepickerModal'
import ErrorModal from '../ErrorModal/ErrorModal'
import { supportedShipsByBrand } from '../../configuration/constants'

const BrandForm = ({
  selectedShipCode,
  setSelectedShipCode,
  selectedDate,
  setSelectedDate,
  isDayHighlighted,
  brandCode,
  videoUrl,
  logoUrl,
  title,
  description,
  copyright,
  footerLinks,
  ships,
  submitUrl,
  isValidSearch,
}) => {
  const [modalIsOpen, setModalIsOpen] = useState(false)

  const onSearchClick = () => {
    if (isValidSearch) {
      window.open(submitUrl)
    } else {
      setModalIsOpen(true)
    }
  }

  const handleDateChange = momentObj => {
    setSelectedDate(momentObj.toDate())
  }

  const brandClass = `brand-${brandCode}`

  let targetCalDate = moment()

  if (
    supportedShipsByBrand?.[brandCode]?.[selectedShipCode]?.startDate &&
    moment(
      supportedShipsByBrand[brandCode]?.[selectedShipCode]?.startDate,
    ).isAfter(targetCalDate, 'days')
  ) {
    targetCalDate = moment(
      supportedShipsByBrand[brandCode][selectedShipCode].startDate,
    )
  }

  return (
    <div className={`brand-content ${brandClass}`}>
      <ErrorModal
        message={{ 1: 'Something went wrong' }}
        isOpen={modalIsOpen}
        onRequestClose={() => setModalIsOpen(false)}
        brandCode={brandCode}
      />
      <div className="background">
        {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
        <video autoPlay muted loop preload="auto">
          <source src={videoUrl} type="video/mp4" />
        </video>
      </div>
      <div className="form-wrapper grid">
        <img className="logo" src={logoUrl} alt="logo" />
        {/* eslint-disable-next-line react/no-danger */}
        <div className="header" dangerouslySetInnerHTML={{ __html: title }} />
        <div className="content">{description}</div>
        <div className="form-wrapper__fields">
          <ShipSelect
            currentShipCode={selectedShipCode}
            setCurrentShipCode={setSelectedShipCode}
            ships={ships}
          />
          <DatepickerModal
            selectedDate={selectedDate ?? ''}
            handleDateChange={handleDateChange}
            isDayHighlighted={isDayHighlighted}
            disabled={!selectedShipCode}
            className={brandClass}
            targetCalDate={targetCalDate}
          />
          <button
            type="button"
            className="btn-search"
            onClick={onSearchClick}
            disabled={!submitUrl}
          >
            Begin Search
          </button>
        </div>
        <div className="footer">
          <div className="copyright">{copyright}</div>
          <div className="links">
            {footerLinks.map((link, index) => (
              <a key={index} href={link.href} target="_blank" rel="noreferrer">
                {link.text}
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

BrandForm.propTypes = {
  selectedShipCode: PropTypes.string,
  setSelectedShipCode: PropTypes.func.isRequired,
  selectedDate: PropTypes.string,
  setSelectedDate: PropTypes.func.isRequired,
  isDayHighlighted: PropTypes.func.isRequired,
  brandCode: PropTypes.string.isRequired,
  logoUrl: PropTypes.string.isRequired,
  videoUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  copyright: PropTypes.string.isRequired,
  footerLinks: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
    }).isRequired,
  ).isRequired,
  ships: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
  submitUrl: PropTypes.string,
  isValidSearch: PropTypes.bool.isRequired,
}

BrandForm.defaultProps = {
  selectedShipCode: null,
  selectedDate: null,
  submitUrl: null,
}

export default BrandForm
